((TopCategories, $) => {
  'use strict'

  const darkenClass = 'top-categories-item--darken';
  const $window = $(window);

  let $topCategories;
  let $item;

  const cacheDom = () => {
    $topCategories = $('.js-top-categories');
    $item = $topCategories.find('.js-top-categories-item');
  };

  const bindUIActions = () => {
    $item.on('mouseenter', function darken() {
      if ($window.width() > 991) {
        const $this = $(this);

        $item.not($this).addClass(darkenClass);
        $this.removeClass(darkenClass);
      }
    });

    $item.on('mouseleave', () => {
      if ($window.width() > 991) {
        $item.removeClass(darkenClass);
      }
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  TopCategories.init = init;
})(window.TopCategories = window.TopCategories || {}, jQuery);
